import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { GLOBALSTATS_STATES } from "../../../containers/GlobalStats/GlobalStats.constants";
import { getBurn } from "../../../containers/Burn/Burn.actions";
import { Card } from "antd";
import ProtocolStat from "./ProtocolStat/ProtocolStat";
import "./ProtocolStats.scss";

export default function ProtocolStats() {
  const dispatch = useDispatch();
  const { status, data } = useSelector((state: any) => state.GlobalStats);
  const [dateRange] = useState([moment().subtract(1, "day"), moment()]);
  const [burnTotal, setBurnTotal] = useState(0);
  const [tpsCount, setTpsCount] = useState(0);
  const { status: burnStatus, data: burnData } = useSelector(
    (state: any) => state.Burn
  );

  const { status: blocksStatus, data: Blocks } = useSelector(
    (state: any) => state.Blocks
  );

  useEffect(() => {
    if (blocksStatus === "success") {
      try {
        setTpsCount(Blocks[0].txns.length);
      } catch (e) {
        setTpsCount(0);
      }
    } else {
      setTpsCount(0);
    }
  }, [blocksStatus, Blocks]);

  useEffect(() => {
    getBurn(dispatch, "rise", dateRange, 24, 24);
  }, [dispatch, dateRange]);

  useEffect(() => {
    if (burnStatus === "success") {
      let burnSum = 0;
      burnData.forEach((item) => (burnSum = burnSum + Number(item.burnAmount)));
      burnSum = burnSum / 100000000;
      setBurnTotal(burnSum);
    }
  }, [burnData, burnStatus]);

  return (
    <Card className="ProtocolStats">
      {status === GLOBALSTATS_STATES.success ? (
        <div className="ProtocolStats__container">
          <div className="ProtocolStats__container__column">
            <ProtocolStat
              title="Centric Rise Price"
              value={data.current.priceInDecimal}
              precision={4}
              prefix="$"
              suffix="USD"
              formatMoney={true}
              tooltipText={
                <span>
                  Current CNR protocol enforced price. 1 CNR ={" "}
                  {data.current.priceInDecimal} CNS. (Updates hourly)
                </span>
              }
            />
            <ProtocolStat
              title="Centric Cash Price"
              value={data.cash.priceInDecimal}
              precision={4}
              prefix="$"
              suffix="USD"
              formatMoney={true}
              tooltipText={
                <span>
                  Current CNS price.
                  <br />
                  Source: CoinMarketCap
                </span>
              }
            />
          </div>
          <div className="ProtocolStats__container__column">
            <ProtocolStat
              title="Centric Rise Max Supply"
              value={data.rise.circulatingSupplyInDecimal}
              prefix={null}
              precision={2}
              suffix="CNR"
              formatMoney={true}
              tooltipText={
                "Remaining CNR left in the Centric Protocol. (Updates hourly)"
              }
            />
            <ProtocolStat
              title="Centric Cash Circulating Supply"
              value={data.cash.circulatingSupplyInDecimal}
              prefix={null}
              precision={2}
              suffix="CNS"
              formatMoney={true}
              tooltipText={
                <span>
                  Circulating CNS. <br />1 CNS requires{" "}
                  {data.protocolRate} CNR to be held as security.
                </span>
              }
            />
          </div>
          <div className="ProtocolStats__container__column">
            <ProtocolStat
              title="Protocol Locked"
              value={data.rise.quarantinedInDecimal}
              prefix={null}
              precision={2}
              suffix="CNR"
              formatMoney={true}
              tooltipText={"CNR held as security by the Centric protocol."}
            />
            <ProtocolStat
              title="Protocol Claim"
              value={data.protocolClaim}
              prefix={null}
              precision={2}
              suffix="CNR"
              formatMoney={true}
              tooltipText={"Current value of circulating CNS in CNR."}
            />
          </div>
          <div className="ProtocolStats__container__column">
            <ProtocolStat
              title="Burned (All Time)"
              value={data.rise.totalBurntInDecimal}
              prefix={null}
              precision={2}
              suffix="CNR"
              formatMoney={true}
              tooltipText={"Total CNR burnt from circulation."}
            />
            <ProtocolStat
              title="Burned (24h)"
              value={burnTotal}
              prefix={null}
              precision={2}
              suffix="CNR"
              formatMoney={true}
              tooltipText={"CNR burnt from circulation in the last 24 hours."}
            />
          </div>
          <div className="ProtocolStats__container__column">
            <ProtocolStat
              title="Current Price Block"
              value={data.priceBlock}
              prefix={null}
              precision={0}
              suffix={null}
              formatMoney={false}
              tooltipText={"Active protocol price marker. (Updates hourly)"}
            />
            <ProtocolStat
              title="Current/Max TPS"
              value={tpsCount}
              prefix={null}
              precision={0}
              suffix={"/748"}
              formatMoney={true}
              tooltipText={"Transactions per second."}
            />
          </div>
        </div>
      ) : null}
    </Card>
  );
}
